export enum TicketStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
    AWAITING_APPROVAL = "AWAITING APPROVAL",
    PENDING_APPROVAL = "PENDING_APPROVAL",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    PREPARING_DEVICE = "PREPARING DEVICE",
    CANCELLED = "CANCELLED",
    RESOLVED = "RESOLVED",
    SUBMITTED = "SUBMITTED",
    INPROGRESS = "IN PROGRESS",
    UNDERINVESTIGATION = "UNDER INVESTIGATION",
    DEVICEINTRANSIT = "DEVICE IN TRANSIT",
    NOLONGERREQUIRED = "NO LONGER REQUIRED",
    PENDINGCANCELLATION = "PENDING CANCELLATION",
    PCRETURN = "PC RETURN",
    ORDERING_DEVICE = "ORDERING DEVICE",
    APPROVAL_REJECTED = "APPROVAL REJECTED",
    PREPARING_SHIPPING_MATERIALS = "PREPARING SHIPPING MATERIALS",
    OEM_SUBMITTED = "OEM SUBMITTED",
    SHIPPING = "SHIPPING",
    COMPLETED = "COMPLETED",
    OEM_ACKNOWLEDGED = "OEM ACKNOWLEDGED",
    OEM_DELIVERED = "OEM DELIVERED",
    OEM_SHIPPED = "OEM SHIPPED",
    OEM_COMPLETED = "OEM COMPLETED",
    AWAITING_APPROVAL_DELEGATED = "AWAITING APPROVAL DELEGATED",
    REJECTED_DELEGATED = "REJECTED DELEGATED",
    APPROVED_DELEGATED = "APPROVED DELEGATED",
}

export enum ResourceType {
    Orders = 'orders',
    Approvals = 'approvals',
    Incidents = 'incidents',
    Requests = 'requests',
}